import React from "react";
import "./CustomToolTip.css";

const commas = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

class CustomToolTip extends React.Component {

    render() {
        return(
            <div className="toolTip">
                <h5 id="cohortName">{"Families making from " + this.props.toolTipTitle}</h5>
                <h6 id="barTitle">{"Net price at a " + this.props.barTitle + " two year institution"}</h6>
                <h2 id="netPrice">{"$" + commas(this.props.netPrice)}</h2>
            </div>
        );
    }

}

export default CustomToolTip;